// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { wrenchHammer16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-wrench-hammer': IconWrenchHammer;
    }
}

/**
 * The icon component for the 'wrenchHammer' icon
 */
export class IconWrenchHammer extends Icon {
    public constructor() {
        super(wrenchHammer16X16);
    }
}

registerIcon('icon-wrench-hammer', IconWrenchHammer);
export const iconWrenchHammerTag = 'nimble-icon-wrench-hammer';
